import ServicePageTemplate from '../ServicePageTemplate';
import { drivewayFaqs } from '../../../mocks/faqs';

export default function PaverDriveways() {
  return (
    <ServicePageTemplate
      heroTitle="Custom Paver Driveway Installation"
      heroSubtitle="Elevate your home's curb appeal with a precision-crafted driveway using premium interlocking pavers built to last Florida's climate."
      heroImage="https://www.parksidepavers.com/files/projects/14/images/thumb/thumb_large_IMG%5F2835%2Ejpg"
      serviceBreakdownTitle="Our Driveway Installation Services"
      serviceBreakdown={[
        { title: 'Custom Driveway Design', desc: 'Personalized layouts, patterns, and material choices matched to your home\'s architecture.', icon: 'ri-pencil-ruler-2-line' },
        { title: 'Full Base Preparation', desc: 'Proper excavation and compacted base that prevents settling and shifting over time.', icon: 'ri-stack-line' },
        { title: 'Premium Paver Brands', desc: 'We install Belgard, Tremron, and other top-rated paver brands for maximum durability.', icon: 'ri-award-line' },
        { title: 'Edge Restraints & Sealing', desc: 'Professional edge installation and sealing to protect and lock in your new driveway.', icon: 'ri-shield-check-line' },
      ]}
      aiAnswerText="Paver driveway installation involves designing and constructing a durable vehicle surface using interlocking pavers. Unlike poured concrete, paver driveways provide excellent load distribution, are easier to repair, and offer superior visual appeal. Parkside Pavers handles all phases from excavation and base preparation to final installation and sealing throughout Tampa Bay, Florida."
      faqs={drivewayFaqs}
      seoCity="Tampa Bay"
    />
  );
}
